import { render, staticRenderFns } from "./tisPop.vue?vue&type=template&id=a684d28c&scoped=true"
import script from "./tisPop.vue?vue&type=script&lang=js"
export * from "./tisPop.vue?vue&type=script&lang=js"
import style0 from "./tisPop.vue?vue&type=style&index=0&id=a684d28c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a684d28c",
  null
  
)

export default component.exports